const config = {
    siteTitle: 'Yahia Bakour',
    siteTitleShort: 'Yahia Bakour',
    siteTitleAlt: "Yahia Bakour's Personal Website",
    siteLogo: '/logos/logo.png',
    siteUrl: 'https://yahia-bakour.netlify.app',
    pathPrefix: '/',
    siteDescription: "Yahia Bakour's Personal Website. A software engineer who enjoys good coffee and fun problems.",
    siteRss: '/rss.xml',
    siteRssTitle: "Yahia Bakour's Personal Website",
    googleAnalyticsID: 'UA-180309786-1',
    dateFromFormat: 'YYYY-MM-DD',
    dateFormat: 'DD/MM/YYYY',
    postsPerPage: 0,
    userName: 'Yahia Bakour',
    userEmail: 'bakour@hey.com',
    userLocation: 'Seattle, WA',
    copyright: 'Copyright © 2020. Yahia Bakour',
    themeColor: '#c62828',
    backgroundColor: '#e0e0e0',
};

// Validate stuff

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
    config.pathPrefix = '';
} else {
    // Make sure pathPrefix only contains the first forward slash
    config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/') {
    config.siteUrl = config.siteUrl.slice(0, -1);
}

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/') {
    config.siteRss = `/${config.siteRss}`;
}

module.exports = config;
